const showSentryDevTest =
  import.meta.env.DEV && import.meta.env.VITE_SENTRY_DEBUG === '1'

/** Alleen lokaal met VITE_SENTRY_DEBUG=1 — triggert ErrorBoundary → Sentry. */
export function SentryDevTestButton () {
  if (!showSentryDevTest) return null

  return (
    <button
      type="button"
      aria-label="Sentry testfout triggeren"
      onClick={() => {
        throw new Error('sentry lokaal test')
      }}
      className="fixed bottom-4 right-4 z-[99999] rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white shadow-lg hover:bg-red-700"
    >
      Sentry test
    </button>
  )
}
